import { openBlock as t, createElementBlock as e, createElementVNode as c } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, o = /* @__PURE__ */ c("mask", {
  id: "tick-square_svg__a",
  fill: "currentColor"
}, [
  /* @__PURE__ */ c("path", { d: "M12.5 18.958h-5c-4.525 0-6.458-1.933-6.458-6.458v-5c0-4.525 1.933-6.458 6.458-6.458h5c4.525 0 6.458 1.933 6.458 6.458v5c0 4.525-1.933 6.458-6.458 6.458m-5-16.666c-3.842 0-5.208 1.366-5.208 5.208v5c0 3.842 1.366 5.208 5.208 5.208h5c3.842 0 5.208-1.366 5.208-5.208v-5c0-3.842-1.366-5.208-5.208-5.208z" })
], -1), s = /* @__PURE__ */ c("path", {
  fill: "currentColor",
  d: "M12.5 17.458h-5v3h5zm-5 0c-2.09 0-3.225-.452-3.866-1.092-.64-.641-1.092-1.776-1.092-3.866h-3c0 2.435.514 4.53 1.971 5.987s3.552 1.971 5.987 1.971zM2.542 12.5v-5h-3v5zm0-5c0-2.09.452-3.225 1.092-3.865S5.41 2.542 7.5 2.542v-3c-2.435 0-4.53.514-5.987 1.971S-.458 5.065-.458 7.5zM7.5 2.542h5v-3h-5zm5 0c2.09 0 3.225.452 3.865 1.093.64.64 1.093 1.775 1.093 3.865h3c0-2.435-.514-4.53-1.971-5.987S14.935-.458 12.5-.458zM17.458 7.5v5h3v-5zm0 5c0 2.09-.452 3.225-1.093 3.866-.64.64-1.775 1.092-3.865 1.092v3c2.435 0 4.53-.514 5.986-1.971 1.458-1.458 1.972-3.552 1.972-5.987zM7.5.792c-2.027 0-3.848.345-5.106 1.603S.792 5.473.792 7.5h3c0-1.815.338-2.598.724-2.984s1.169-.724 2.984-.724zM.792 7.5v5h3v-5zm0 5c0 2.027.344 3.848 1.602 5.105s3.08 1.603 5.106 1.603v-3c-1.815 0-2.599-.338-2.984-.724-.386-.386-.724-1.169-.724-2.984zM7.5 19.208h5v-3h-5zm5 0c2.027 0 3.847-.344 5.105-1.602s1.603-3.08 1.603-5.106h-3c0 1.815-.338 2.598-.724 2.984s-1.17.724-2.984.724zm6.708-6.708v-5h-3v5zm0-5c0-2.027-.345-3.847-1.603-5.105S14.527.792 12.5.792v3c1.815 0 2.598.338 2.984.724s.724 1.17.724 2.984zM12.5.792h-5v3h5z",
  mask: "url(#tick-square_svg__a)"
}, null, -1), r = /* @__PURE__ */ c("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "m13.453 7.545-.353-.353zM6.37 10.089l-.353.353z"
}, null, -1), v = [
  o,
  s,
  r
];
function n(l, z) {
  return t(), e("svg", h, [...v]);
}
const m = { render: n };
export {
  m as default,
  n as render
};
